// File generated from our OpenAPI spec
import { StripeResource } from '../StripeResource.js';
const stripeMethod = StripeResource.method;
export const CustomerSessions = StripeResource.extend({
    create: stripeMethod({ method: 'POST', fullPath: '/v1/customer_sessions' }),
});
